module.exports = {"ERROR_MESSAGES":{"EMAIL":"email.0","FIRST_NAME":"first_name.0","LAST_NAME":"last_name.0","PHONE_NUMBER":"phone.0","PASSWORD":"password.0","CONFIRM":"confirm.0","DATE_OF_BIRTH":"date_of_birth.0","VERIFICATION_CODE":"verification_code.0","API_ERROR":"non_field_errors"},"SMS_ERROR_KEY":"verification_code"}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/integrationMaps/signup.json
// module id = 1758
// module chunks = 1